import React, { useEffect, useMemo } from 'react';
import FilterOption from 'components/Filters/FilterOption';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { searchActionsEnum } from '../../../config/constants';
import { useSearchContext } from '../../../contexts';
import { definedTranslation } from '../../../i18n';
import {
  appFiltersKeysSelector,
  searchToggleSelector,
} from '../../../redux/selectors/filtersSelector';
import { searchOptionsSelector } from '../../../redux/selectors/searchSelector';
import { setSearchToggle } from '../../../redux/sliceCreators/filtersSlice';

export const individualToggle = 'individual';
export const familyToggle = 'families';

const FamilyViewSwitch = () => {
  const { search } = useSearchContext();
  const searchOptions = useSelector(searchOptionsSelector);
  const searchToggle = useSelector(searchToggleSelector);
  const currentFilterKeys = useSelector(appFiltersKeysSelector);
  const dispatch = useDispatch();

  const isColorApplied = useMemo(() => {
    return currentFilterKeys?.some((item) => item.includes('virtual_color'));
  }, [currentFilterKeys]);

  useEffect(() => {
    window.addEventListener('triggerFamilyToggleSearch', (e: CustomEvent) =>
      triggerSearch(e?.detail),
    );
    return () => {
      window.removeEventListener(
        'triggerFamilyToggleSearch',
        (e: CustomEvent) => triggerSearch(e?.detail),
      );
    };
  }, []);

  const triggerSearch = (value: string) => {
    search(
      {
        ...searchOptions,
        action: searchActionsEnum.filter,
        page: 1,
      },
      false,
      value,
    );
  };

  const handleChange = async () => {
    if (isColorApplied) return;

    const newSearchToggle =
      searchToggle === individualToggle ? familyToggle : individualToggle;

    dispatch(setSearchToggle(newSearchToggle));
    const familyToggleClick = new CustomEvent('family-toggle-click');
    window.dispatchEvent(familyToggleClick);
    triggerSearch(newSearchToggle);
  };

  return (
    <FilterOption
      isSwitch
      isSelected={searchToggle === individualToggle}
      onClick={handleChange}
      disabled={isColorApplied}
    >
      <FormattedMessage {...definedTranslation.filters.colorwaysToggle} />
    </FilterOption>
  );
};

export { FamilyViewSwitch };
